<template>
  <div id="content-event" class="col-12">
    <div class="form">
      <dl class="row">
        <dt class="col-md-3 text-end">เงื่อนไขการรับสิทธิ์</dt>
        <dd class="col-md-9">
          <label class="select-input">
            <span>รับสิทธิ์ทันที</span>
            <input
              v-model="eventType"
              type="radio"
              value="IMMEDIATE"
              name="type"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>ลงทะเบียน</span>
            <input
              v-model="eventType"
              type="radio"
              value="REGISTER"
              name="type"
            />
            <span class="checkmark radio"></span>
          </label>
          <dl v-if="showTypeOption" class="form-options">
            <dt></dt>
            <dd>
              <label class="select-input">
                <span>ให้มีคำถามในหน้าแบบฟอร์มลงทะเบียน</span>
                <input v-model="haveRegistrationQuestion" type="checkbox" />
                <span class="checkmark checkbox"></span>
              </label>
              <div v-if="haveRegistrationQuestion" class="sub-input w-100">
                <small>พิมพ์คำถามที่คุณต้องการ</small>
                <input
                  v-model="registrationQuestion"
                  type="text"
                  name="question"
                  class="form-control"
                />
              </div>
            </dd>
          </dl>
        </dd>
        <dt class="col-md-3 text-end">รูปแบบ Ticket</dt>
        <dd class="col-md-9">
          <label class="select-input">
            <span>Activity Ticket</span>
            <input
              v-model="usageType"
              type="radio"
              value="ACTIVITY"
              name="usageType"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>Redeem Ticket</span>
            <input
              v-model="usageType"
              type="radio"
              value="REDEEM"
              name="usageType"
            />
            <span class="checkmark radio"></span>
          </label>
        </dd>
        <dt class="col-md-3 text-end">ระยะเวลารับสิทธิ์ / ลงทะเบียน</dt>
        <dd class="col-md-9">
          <label class="form-group">
            <small>วันที่ / เวลา</small>
            <div class="clearfix">
              <el-date-picker
                v-model="activateDate"
                :editable="false"
                :picker-options="datePickerOptions.notBeforeToday"
                :default-time="['00:00:00', '23:59:59']"
                format="dd-MM-yyyy HH:mm"
                start-placeholder="เริ่มการลงทะเบียน"
                end-placeholder="สิ้นสุดการลงทะเบียน"
                range-separator="ถึง"
                type="datetimerange"
              ></el-date-picker>
            </div>
          </label>
        </dd>
        <dt class="col-md-3 text-end">รูปแบบรหัส</dt>
        <dd class="col-md-9">
          <label class="select-input">
            <span>กำหนดเอง</span>
            <input
              v-model="codeType"
              type="radio"
              value="PREFIXED"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>อัพโหลดไฟล์รหัส</span>
            <input
              v-model="codeType"
              type="radio"
              value="PREDEFINED"
            />
            <span class="checkmark radio"></span>
          </label>
          <dl class="form-options">
            <div v-if="showSetCodeOptions">
              <dt>กำหนดรูปแบบรหัส</dt>
              <dd>
                <label class="form-group">
                  <small>ระบุภาษาอังกฤษขึ้นต้น 2 ตัว</small>
                  <input
                    v-model="prefixCode"
                    type="text"
                    name="prefixCode"
                    class="form-control"
                    maxlength="2"
                    placeholder="SC"
                  />
                </label>
                <label class="form-group">
                  <small>ตัวอย่างรหัส</small>
                  <div class="code-preview">
                    <em>{{ value.prefixCode }}</em>
                    <span>XXXXXX</span>
                  </div>
                </label>
              </dd>
            </div>
            <div v-if="showUploadCodeOptions">
              <dt>อัพโหลดไฟล์ CSV
                <img
                  class="pointer align-top ms-2"
                  src="/static/icons/information-circle.svg"
                  alt="info icon"
                  width="22"
                  height="22"
                  @click="showCsvInfoDialog = true"
                />
              </dt>
              <dd>
                <label class="form-group">
                  <input
                    type="file"
                    class="form-control"
                    accept=".csv"
                    @change="readCodesFromCSV($event.target.files[0])"
                  />
                </label>
                <label class="form-group">
                  <small>จำนวนสิทธิ์</small>
                  <input
                    :value="value.codes.length"
                    type="text"
                    class="form-control"
                    readonly
                  />
                </label>
                <div class="code-results">
                  <ul v-if="value.codes.length > 0" class="">
                    <li>ตัวอย่างรหัสจากไฟล์</li>
                    <li v-for="(code, i) in value.codes" :key="i">
                      {{ code }}
                    </li>
                  </ul>
                </div>
              </dd>
            </div>
            <dt>วันจัดกิจกรรม / ระยะเวลาใช้สิทธิ์</dt>
            <dd>
              <label class="form-group">
                <small>วันที่ / เวลา</small>
                <div class="clearfix">
                  <el-date-picker
                    v-model="useDate"
                    :editable="false"
                    :picker-options="datePickerOptions.notBeforeToday"
                    :default-time="['00:00:00', '23:59:59']"
                    format="dd-MM-yyyy HH:mm"
                    start-placeholder="เริ่มกิจกรรม/ใช้สิทธิ์"
                    end-placeholder="สิ้นสุดกิจกรรม/ใช้สิทธิ์"
                    range-separator="ถึง"
                    type="datetimerange"
                  ></el-date-picker>
                </div>
              </label>
            </dd>
            <div v-if="showSetCodeOptions">
              <dt>จำนวนสิทธิ์</dt>
              <dd>
                <div>
                  <label class="select-input">
                    <span>จำกัดสิทธิ์</span>
                    <input
                      v-model="quotaType"
                      type="radio"
                      value="LIMITED"
                      name="quotaType"
                    />
                    <span class="checkmark radio"></span>
                  </label>
                  <label class="select-input">
                    <span>ไม่จำกัดสิทธิ์</span>
                    <input
                      v-model="quotaType"
                      type="radio"
                      value="UNLIMITED"
                      name="quotaType"
                    />
                    <span class="checkmark radio"></span>
                  </label>
                </div>
                <div v-if="showSpecificQuotaOptions">
                  <label class="sub-input">
                    <small>ระบุจำนวนสิทธิ์</small>
                    <input
                      v-model="quota"
                      type="number"
                      name="quotaPreview"
                      class="form-control"
                      min="1"
                    />
                  </label>
                </div>
              </dd>
            </div>
            <div v-if="showWaitingListOptions">
              <label class="select-input">
                <span>ให้มี Waiting List ( สิทธิ์สำรอง )</span>
                <input
                  v-model="haveWaitingList"
                  type="checkbox"
                />
                <span class="checkmark checkbox"></span>
              </label>
              <div v-if="showWaitingListQuotaOptions">
                <label class="sub-input">
                  <small>ระบุจำนวนสิทธิ์สำรอง</small>
                  <input
                    v-model="totalReserve"
                    type="number"
                    name="totalReserve"
                    class="form-control"
                    min="1"
                  />
                </label>
              </div>
            </div>
          </dl>
        </dd>
        <dt class="col-md-3 text-end">บาร์โค้ด</dt>
        <dd class="col-md-9">
          <label class="select-input">
            <span>แสดงบาร์โค้ด</span>
            <input
              v-model="showBarcode"
              :value="true"
              type="radio"
              name="showBarcode"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>ไม่แสดงบาร์โค้ด</span>
            <input
              v-model="showBarcode"
              :value="false"
              type="radio"
              name="showBarcode"
            />
            <span class="checkmark radio"></span>
          </label>
          <dl v-if="showBarcode" class="form-options">
            <dt>คำอธิบายใต้บาร์โค้ด</dt>
            <dd>
              <label class="form-group">
                <small>แก้ไขคำอธิบาย</small>
                <input
                  v-model="barcodeRemark"
                  type="text"
                  name="barcodeRemark"
                  class="form-control"
                  maxlength="200"
                  placeholder="แสดง code นี้กับเจ้าหน้าที่เพื่อรับสิทธิ์"
                />
              </label>
            </dd>
          </dl>
        </dd>
      </dl>
    </div>
    <info-dialog
      v-if="showCsvInfoDialog === true"
      :title="'รูปแบบของไฟล์ CSV'"
      @isShow="showCsvInfoDialog = false"
    >
      <div class="row">
        <div class="col-md-8">
          <img
            src="/static/pictures/article-guide-csv.jpg"
            alt="csv content guide"
            class="w-100"
          />
        </div>
        <div class="col-md-4">
          <p>
            รูปแบบของรหัส
            จะต้องประกอบด้วยตัวเลขหรือตัวหนังสือภาษาอังกฤษรวมทั้งหมด 8
            ตัวซึ่งจะต้องอยู่ในคอลัมน์เดียว และไม่ต้องใส่หัวตาราง ตามรูปประกอบ
          </p>
        </div>
      </div>
    </info-dialog>
  </div>
</template>

<script>
import Information from "@/components/helper/dialog/Information";

import csv from "csvtojson";
import { DatePicker } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

export default {
  components: {
    "el-date-picker": DatePicker,
    "info-dialog": Information
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    eventConditions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      datePickerOptions: {
        notBeforeToday: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 3600 * 1000 * 24;
          }
        }
      },
      showCsvInfoDialog: false
    };
  },
  computed: {
    showTypeOption() {
      return this.value.type === "REGISTER";
    },
    showSetCodeOptions() {
      return this.codeType === "PREFIXED";
    },
    showUploadCodeOptions() {
      return this.codeType === "PREDEFINED";
    },
    showSpecificQuotaOptions() {
      return this.quotaType === "LIMITED";
    },
    showWaitingListOptions() {
      return this.value.type === "REGISTER" && this.quotaType !== "UNLIMITED";
    },
    showWaitingListQuotaOptions() {
      return this.eventConditions.haveWaitingList;
    },
    eventType: {
      get() {
        return this.value.type;
      },
      set(value) {
        this.emitEvent({ type: value });
      }
    },
    registrationQuestion: {
      get() {
        return this.value.registrationQuestion;
      },
      set(value) {
        this.emitEvent({ registrationQuestion: value });
      }
    },
    usageType: {
      get() {
        return this.value.usageType;
      },
      set(value) {
        this.emitEvent({ usageType: value });
      }
    },
    activateDate: {
      get() {
        return [this.value.startActivateDate, this.value.endActivateDate];
      },
      set(datetimeArray) {
        this.emitDateRange("startActivateDate", "endActivateDate", datetimeArray);
      }
    },
    useDate: {
      get() {
        return [this.value.startUseDate, this.value.endUseDate];
      },
      set(datetimeArray) {
        this.emitDateRange("startUseDate", "endUseDate", datetimeArray);
      }
    },
    prefixCode: {
      get() {
        return this.value.prefixCode;
      },
      set(value) {
        this.emitEvent({ prefixCode: value });
      }
    },
    quota: {
      get() {
        return this.value.quota;
      },
      set(value) {
        this.emitEvent({ quota: value });
      }
    },
    totalReserve: {
      get() {
        return this.value.totalReserve;
      },
      set(value) {
        this.emitEvent({ totalReserve: value });
      }
    },
    showBarcode: {
      get() {
        return this.value.showBarcode;
      },
      set(value) {
        this.emitEvent({ showBarcode: value });
      }
    },
    barcodeRemark: {
      get() {
        return this.value.barcodeRemark;
      },
      set(value) {
        this.emitEvent({ barcodeRemark: value });
      }
    },
    haveRegistrationQuestion: {
      get() {
        return this.eventConditions.haveRegistrationQuestion;
      },
      set(value) {
        this.emitEventConditions({ haveRegistrationQuestion: Boolean(value) });
      }
    },
    codeType: {
      get() {
        return this.eventConditions.codeType;
      },
      set(value) {
        this.emitEventConditions({ codeType: value });
      }
    },
    quotaType: {
      get() {
        return this.eventConditions.quotaType;
      },
      set(value) {
        this.emitEventConditions({ quotaType: value });
      }
    },
    haveWaitingList: {
      get() {
        return this.eventConditions.haveWaitingList;
      },
      set(value) {
        this.emitEventConditions({ haveWaitingList: value });
      }
    }
  },
  methods: {
    emitEvent(payload) {
      this.$emit("setEvent", { ...this.value, ...payload });
    },
    emitEventConditions(payload) {
      this.$emit("setEventConditions", { ...this.eventConditions, ...payload });
    },
    emitDateRange(startKey, endKey, datetimeArray) {
      if (datetimeArray === null) {
        this.emitEvent({
          [startKey]: "",
          [endKey]: ""
        });

        return;
      }

      this.emitEvent({
        [startKey]: datetimeArray[0],
        [endKey]: datetimeArray[1]
      });
    },
    readCodesFromCSV(file) {
      if (!file) {
        this.emitEvent({ codes: [] });

        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        const options = {
          noheader: true,
          ignoreEmpty: true,
          output: "line"
        };

        csv(options)
          .fromString(reader.result)
          .then(lines => {
            const codes = lines
              .map(line => String(line).trim())
              .map(line => line.replace(/[^A-Za-z0-9]/g, ""))
              .filter(code => /^[A-Za-z0-9]{8}$/.test(code));

            this.emitEvent({ codes });
          })
          .catch(() => {
            this.emitEvent({ codes: [] });
          });
      };

      reader.readAsText(file);
    }
  }
};
</script>

<style lang="scss" scoped>
#content-event {
  overflow-y: auto;
  height: calc(100vh - 222px);
}

.form {
  strong {
    display: inline-block;
    vertical-align: bottom;
    margin: 1rem;
  }

  small {
    font-size: 11px;
    font-weight: 500;
    line-height: 1.64;
    letter-spacing: -0.1px;
    color: #8c8786;
  }

  dt {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
  }

  input:not([type="file"]) {
    color: $black;
    font-weight: bold;
    border: none;
    border-bottom: 1px solid #979797;
    border-radius: 0px;
  }

  input:not([type="checkbox"]):not([type="radio"]) {
    padding: 4px 4px 4px 0;
  }

  input[type="file"] {
    height: 35px;
    border: none;
    border-bottom: 1px solid #979797;
    border-radius: 0px;
  }

  input[data-prefix] {
    content: attr(data-prefix);
    color: $black;
    display: inline;
  }

  &-options {
    padding: 16px;
    border-radius: 5px;
    background-color: #f9f9f9;
  }

  dt {
    text-align: left;
  }

  .sub-input {
    padding-left: 36px;
  }

  .form-control {
    background-color: transparent;
    border-color: #e0e0e0;
  }

  .select-input {
    color: $black;
  }

  .time-picker-wrapper {
    font-size: 18px;
    font-weight: bold;
    border: none;
    border-bottom: solid 1px #e0e0e0;
    height: 30px;
    margin-top: 0;
    float: left;
    min-width: 220px;
  }

  .date-append-img {
    float: left;
    margin-top: 5px;
    margin-left: -25px;
  }

  .code-preview {
    margin-top: 4px;
    color: $black;
    font-size: 16px;

    em {
      font-weight: bold;
      font-style: normal;
    }
  }

  .code-results {
    ul {
      padding-left: 0;
      margin: 0;
      max-height: 100px;
      overflow: scroll;

      &.error {
        color: $red;
      }

      li {
        font-size: 11px;
        list-style-type: square;
        margin-left: 16px;

        &:first-child {
          margin-left: 0;
          padding-left: 0;
          list-style: none;
        }
      }
    }
  }
}
</style>
